const FIELD_KEY_ALIASES: Record<string, string> = {
  age: 'age_years',
  age_years: 'age_years',
  age_pna: 'age_pna',
  age_pma: 'age_pma',
  alb: 'albumin',
  albumin: 'albumin',
  birth_date: 'birth_date',
  birthdate: 'birth_date',
  'birth date': 'birth_date',
  bmi: 'bmi',
  bsa: 'bsa',
  case_no: 'patient_code',
  clcr: 'crcl',
  cr: 'scr',
  crcl: 'crcl',
  diagnosis: 'diagnosis',
  dob: 'birth_date',
  drug_name: 'drug_name',
  ecmo: 'ecmo',
  egfr: 'egfr',
  ga: 'gestational_age',
  current_date: 'current_date',
  'current date': 'current_date',
  date_of_birth: 'birth_date',
  'date of birth': 'birth_date',
  gender: 'gender',
  gestational_age: 'gestational_age',
  cancer: 'hema_malig',
  hema_malig: 'hema_malig',
  'hema malig': 'hema_malig',
  'hema-malig': 'hema_malig',
  height: 'height',
  heel: 'heel_prick',
  hospital_no: 'patient_code',
  hospital_number: 'patient_code',
  heel_prick: 'heel_prick',
  'heel prick': 'heel_prick',
  'heel-prick': 'heel_prick',
  ht: 'height',
  inotropes: 'inotropes',
  mrn: 'patient_code',
  patient_code: 'patient_code',
  patient_id: 'patient_code',
  pma: 'age_pma',
  pna: 'age_pna',
  scr: 'scr',
  scr_unit: 'scr_unit',
  sex: 'gender',
  ventilation: 'ventilation',
  weight: 'weight',
  wt: 'weight',
};

const BASE_FORM_FIELD_MAP: Record<string, string> = {
  patient_code: 'patient_id',
  diagnosis: 'diagnosis',
  drug_name: 'drug_name',
};

export function normalizeCanonicalFieldKey(key: string): string {
  const trimmed = String(key || '').trim();
  if (!trimmed) return '';
  return FIELD_KEY_ALIASES[trimmed.toLowerCase()] || trimmed;
}

export function toFormFieldKey(key: string): string {
  const canonical = normalizeCanonicalFieldKey(key);
  return BASE_FORM_FIELD_MAP[canonical] || canonical;
}

export function toAgentFieldKey(key: string): string {
  return normalizeCanonicalFieldKey(key);
}

export function canonicalFieldAliasMap(): Record<string, string> {
  return { ...FIELD_KEY_ALIASES };
}
